<template>
  <div class="d-flex flex-wrap ma-n2">

    <v-btn
      icon large color="#1877f2" target="_blank"
      :href="`https://www.facebook.com/sharer.php?u=${encoded.url}&title=${encoded.title}&description=${encoded.description}&hashtag=%23Ellacard`"
      :disabled="disabled"
      @click="record('facebook')"
    >
      <v-icon large v-html="mdiFacebook" />
    </v-btn>

    <v-btn
      icon large color="#007bb5" target="_blank"
      :href="`https://linkedin.com/sharing/share-offsite/?url=${encoded.url}`"
      :disabled="disabled"
      @click="record('linkedin')"
    >
      <v-icon large v-html="mdiLinkedin" />
    </v-btn>

    <v-btn
      v-if="!link"
      icon large color="#bd081c" target="_blank"
      :href="`http://pinterest.com/pin/create/button/?url=${encoded.url}&title=${encoded.title}&description=${encoded.description}&media=${encoded.media}`"
      :disabled="disabled || !encoded.media"
      @click="record('pinterest')"
    >
      <v-icon large v-html="mdiPinterest" />
    </v-btn>

    <v-btn
      icon large color="#ff4500" target="_blank"
      :href="`https://reddit.com/submit?url=${encoded.url}&title=${encoded.title}`"
      :disabled="disabled"
      @click="record('reddit')"
    >
      <v-icon large v-html="mdiReddit" />
    </v-btn>

    <v-btn
      icon large color="#000" target="_blank"
      :href="`https://x.com/intent/tweet?url=${encoded.url}&text=${encoded.description}&hashtags=Ellacard`"
      :disabled="disabled"
      @click="record('twitter')"
    >
      <v-icon large v-html="iconPathX" />
    </v-btn>

    <v-btn icon large :disabled="disabled" @click="record('link'); copyToClipboard(shareURL, { msg: 'Link copied' })">
      <v-icon large v-html="mdiLinkVariant" />
    </v-btn>
  </div>
</template>

<script>
import { waitHydrated } from '@/mixins/ssr.js';
import iconPathX from 'raw-loader!@/assets/icon-path-x.txt';
import { mdiFacebook, mdiLinkedin, mdiPinterest, mdiReddit, mdiLinkVariant } from '@mdi/js';

export default {
  name: 'social-share-btns',

  props: {
    title: String,
    description: String,
    url: String,
    disabled: Boolean,
    link: Boolean
  },

  computed: {
    shareURL() {
      return this.url || this.$route && window.location.href;
    },

    encoded() {
      const img = this.$router.currentRouteMeta.image;
      return {
        title: encodeURIComponent(this.title),
        description: encodeURIComponent(this.description),
        url: encodeURIComponent(this.shareURL),
        media: img ? encodeURIComponent(img) : undefined
      };
    }
  },

  created() {
    Object.assign(this, { iconPathX, mdiFacebook, mdiLinkedin, mdiPinterest, mdiReddit, mdiLinkVariant });
  },

  methods: {
    record(target) {
      $event.log('share', { target, url: this.shareURL });
    }
  }
}
</script>
